import React from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import classNames from 'classnames'
import {SearchResult} from 'jbc-front/components/SearchForm'
import {getSavedDisplayEmployeeLimit, saveDisplayEmployeeLimit} from 'documents/contract/utils'
import styles from 'documents/Contract.scss'

const options = ['10', '20', '50', '100', '200']

const PerPageWithResult = ({total, page, loading, onChange}) => {
  const {pathname} = useLocation()
  const user = useSelector((state) => state.session.currentUser)
  const limit = getSavedDisplayEmployeeLimit(pathname, user)
  const onChangeLimit = (e) => {
    onChange()
    saveDisplayEmployeeLimit(pathname, user, e.target.value)
  }

  return (
    <div className={classNames('u-mt10', styles.PerPageWithResult)}>
      <div className={styles.searchSelectBox}>
        <select type="select" onChange={onChangeLimit} className={styles.select} value={limit}>
          {options.map((perPage) => (
            <option key={perPage} value={perPage}>
              {perPage}件を表示
            </option>
          ))}
        </select>
      </div>
      <div className={styles.listTypeSearchResult}>
        <SearchResult total={total} page={page} limit={limit} isLoading={loading} />
      </div>
      <div className={classNames('u-mb10', styles.resultRight)} />
    </div>
  )
}

export default PerPageWithResult
